<template>
  <b-navbar type="light" variant="light" class="top-nav flex-row mx-n3 shadow-sm">
    <a class="btn btn-outline-dark d-md-none" href="#">
      <fa-icon icon="bars" />
    </a>
    <a class="navbar-brand d-md-none ml-2" href="/">
      <fa-icon icon="phone-volume" /> <strong>АТС</strong>
    </a>

    <b-navbar-nav class="ml-auto d-flex flex-row">
      <b-nav-form class="mr-2" v-if="false">
        <b-button variant="outline-secondary">
          <fa-icon icon="exclamation-circle" /> <span class="badge badge-danger">2</span>
        </b-button>
      </b-nav-form>
      <b-nav-item-dropdown v-if="appState.user" right>
        <template v-slot:button-content>
          <fa-icon icon="user" /> <span class="d-none d-md-inline">{{ appState.user.username }}</span>
        </template>
        <b-dropdown-text class="d-md-none"><fa-icon icon="user" /> {{ appState.user.username }}</b-dropdown-text>
        <b-dropdown-divider class="d-md-none"></b-dropdown-divider>
        <b-dropdown-item href="#"><fa-icon icon="user-cog" /> Настройки</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click.prevent.stop="logout">
          <fa-icon icon="sign-out-alt" /> Выйти
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import Api from "@/lib/Api";
import { store } from '@/store';
import EventBus from '@/lib/EventBus';


export default {
    name: 'TopNav',
    data () {
        return {
            appState: store.state,
        };
    },
    methods: {
        async logout () {
            EventBus.$emit('set-loading', true);
            this.loading = true;
            try {
                await Api.logout();
                store.setAuth(null);
                this.$router.push({name: 'login'});
                this.$root.$bvToast.toast('Вы успешно вышли', {
                    title: '',
                    variant: 'success',
                    solid: true,
                });
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Невозможно выйти из системы', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            EventBus.$emit('set-loading', false);
        }
    },
}
</script>
